import { Flex } from '@mantine/core';
import { memo, useCallback } from 'react';
import type { IntegrationMetricCardType } from '../../types';
import { ErrorIcon, NormalIcon } from '../icons';
import { MetricsOverviewCard } from '../MetricsOverviewCard';

export type IntegrationMetrics = {
	status_counts: {
		normal: number;
		error: number;
	};
};

export interface MetricsIntegrationCardsProps {
	integrationMetrics: IntegrationMetrics;
	onMetricCardClick?: (metricType: IntegrationMetricCardType) => void;
}

export const MetricsIntegrationCards = memo(
	({ integrationMetrics, onMetricCardClick }: MetricsIntegrationCardsProps) => (
		<Flex py="lg" w="100%" justify="space-between" align="center" gap="md">
			<MetricsOverviewCard
				title="Completed sync"
				value={integrationMetrics?.status_counts?.normal ?? 0}
				icon={NormalIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Completed Sync'),
					[onMetricCardClick]
				)}
			/>
			<MetricsOverviewCard
				title="Failed sync"
				value={integrationMetrics?.status_counts?.error ?? 0}
				icon={ErrorIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Failed'),
					[onMetricCardClick]
				)}
			/>
		</Flex>
	)
);

MetricsIntegrationCards.displayName = 'MetricsIntegrationCards';
